// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ht-slider-control {
  position: relative;
}
.ht-slider-control .ht-slider-wrapper {
  padding: 35px 15px 50px;
}
.ht-slider-control .ht-slider-wrapper .step-container {
  position: relative;
  top: 22px;
}
.ht-slider-control .ht-slider-wrapper .step-container .slider-step {
  position: absolute;
  width: 10px;
  height: 10px;
  border-radius: 10px;
  background-color: #006b57;
  margin: -5px -5px -5px -5px;
}
.ht-slider-control .ht-slider-wrapper .step-container .slider-step .slider-step-inner {
  display: block;
  position: relative;
  top: -45px;
  text-align: center;
}
.ht-slider-control .ht-slider-wrapper .slider {
  height: 45px;
  position: relative;
}
.ht-slider-control .ht-slider-wrapper .bar {
  margin-top: 21px;
  height: 2px;
  background-color: #006b57;
}
.ht-slider-control .ht-slider-wrapper .handle:focus {
  outline: none;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 8px rgba(102, 175, 233, 0.6);
}
.ht-slider-control .ht-slider-wrapper .handle:focus .handler {
  outline: none;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 8px rgba(102, 175, 233, 0.6);
}
.ht-slider-control .ht-slider-wrapper .handle .handler {
  margin-left: -15px;
  margin-right: -15px;
  width: 30px;
  height: 45px;
  background: #f4f7f6;
  box-shadow: 0 0 3px rgba(0, 0, 0, 0.5);
  text-align: center;
  cursor: pointer;
}
.ht-slider-control .ht-slider-wrapper .handle .handler .handler-bar {
  display: inline-block;
  background-color: #006b57;
  width: 1px;
  height: 24px;
  margin: 10px 2px 0;
}
.ht-slider-control .popover.bottom {
  margin-top: 15px;
  margin-left: -14px;
}
`, "",{"version":3,"sources":["webpack://./../styleguide/src/components/Slider/main.less"],"names":[],"mappings":"AAKA;EACE,kBAAA;AAJF;AAGA;EAII,uBAAA;AAJJ;AAAA;EAOM,kBAAA;EACA,SAAA;AAJN;AAJA;EAWQ,kBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,2BAAA;AAJR;AAZA;EAmBU,cAAA;EACA,kBAAA;EACA,UAAA;EACA,kBAAA;AAJV;AAlBA;EA4BM,YAAA;EACA,kBAAA;AAPN;AAtBA;EAiCM,gBAAA;EACA,WAAA;EACA,yBAAA;AARN;AAYM;EACE,aAAA;EACA,kFAAA;AAVR;AAQM;EAKI,aAAA;EACA,kFAAA;AAVV;AAnCA;EAkDQ,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,sCAAA;EACA,kBAAA;EACA,eAAA;AAZR;AA7CA;EA4DU,qBAAA;EACA,yBAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;AAZV;AApDA;EAuEI,gBAAA;EACA,kBAAA;AAhBJ","sourcesContent":["@import '~styleguide/src/styles/variables.less';\n\n@handler-color: @bkgdBlue;\n@bar-color: @shadowGreen;\n\n.ht-slider-control {\n  position: relative;\n\n  .ht-slider-wrapper {\n    padding: 35px 15px 50px;\n\n    .step-container {\n      position: relative;\n      top: 22px;\n\n      .slider-step {\n        position: absolute;\n        width: 10px;\n        height: 10px;\n        border-radius: 10px;\n        background-color: @bar-color;\n        margin: -5px -5px -5px -5px;\n\n        .slider-step-inner {\n          display: block;\n          position: relative;\n          top: -45px;\n          text-align: center;\n        }\n      }\n    }\n\n    .slider {\n      height: 45px;\n      position: relative;\n    }\n\n    .bar {\n      margin-top: 21px;\n      height: 2px;\n      background-color: @bar-color;\n    }\n\n    .handle {\n      &:focus {\n        outline: none;\n        box-shadow: @input-focus-shadow;\n\n        .handler {\n          outline: none;\n          box-shadow: @input-focus-shadow;\n        }\n      }\n\n      .handler {\n        margin-left: -15px;\n        margin-right: -15px;\n        width: 30px;\n        height: 45px;\n        background: @handler-color;\n        box-shadow: 0 0 3px rgba(0, 0, 0, 0.5);\n        text-align: center;\n        cursor: pointer;\n\n        .handler-bar {\n          display: inline-block;\n          background-color: @bar-color;\n          width: 1px;\n          height: 24px;\n          margin: 10px 2px 0;\n        }\n      }\n    }\n  }\n\n  .popover.bottom {\n    margin-top: 15px;\n    margin-left: -14px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
